<div class="loading" [hidden]="!show_loading">
  <div class="loader">Loading...</div>
</div>

<!-- Step 1 -->
<div class="container">
  <div class="row d-flex full-height">
    <div class="col-sm-5 shade-bg d-flex flex-column pe-5">
      <img src="assets/img/logo-default.svg" width="150" alt="Client Hub" />

      <div class="headline">
        <h6 style="text-transform: uppercase; opacity: 0.8; font-weight: 600">
          Step {{ currStep }} of 2
        </h6>
        @if (currStep === 1) {
          <div>
            <h2 class="mb-2">Start a Trial</h2>
            <p>
              Jump right in! Get unlimited access to
              all features, plus access to all the resources and training you need
              to hit the ground running and really make the most of it.
              <!-- <a (click)="isCollapsed = !isCollapsed">Know more</a>. -->
            </p>
            @if (!isCollapsed) {
              <div>
                <p style="font-size: 14px">
                  If you don't need the Premium features, go to the Billing Portal
                  within Client Hub and change your plan to Standard at any point
                  during or after your trial.
                </p>
              </div>
            }
          </div>
        }
        @if (currStep === 2) {
          <h2>Add your payment details</h2>
        }
        @if (currStep === 2) {
          <p>We ask for your payment details now to make continuing after your trial seamless.
          No charges during your trial — cancel anytime from Manage Practice page.</p>
        }
      </div>

      <div
        class="illustration"
        style="align-items: flex-start; margin-top: 243px"
        >
        <div class="testimonial">
          <div class="testimonial-avatar-name">
            <div
              class="testimonial-avatar"
              style="background: url(assets/img/landing-page-v3/blake.png)"
            ></div>
            <div class="testimonial-name">
              Blake Oliver<br />
              <strong>Founder &#64; Earmark App</strong>
            </div>
          </div>
          <div class="testimonial-text">
            When I ran my firm, I dreamed about having an app just like this
            that can solve these exact pain points. Bravo to Client Hub for
            actually doing it.
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 offset-sm-1">
      <!-- Form -->
      @if (currStep === 1) {
        <div class="form">
          <div class="form-group">
            <label for="firmname">Firm name</label>
            <input
              required
              [(ngModel)]="accountingCompanyName"
              type="text"
              id="firmname"
              name="organization"
              autocomplete="organization"
              class="form-control"
              placeholder="Firm name"
              autofocus
              cdkAutofill
              (cdkAutofill)="onAutofill($event)"
              />
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="firstname">First name</label>
                <input
                  required
                  [(ngModel)]="ownerFirstName"
                  type="text"
                  id="firstname"
                  name="fname"
                  autocomplete="given-name"
                  class="form-control"
                  placeholder="Your first name"
                  cdkAutofill
                  (cdkAutofill)="onAutofill($event)"
                  />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="lastname">Last name</label>
                <input
                  required
                  [(ngModel)]="ownerLastName"
                  type="text"
                  id="lastname"
                  name="lname"
                  autocomplete="family-name"
                  class="form-control"
                  placeholder="Your last name"
                  cdkAutofill
                  (cdkAutofill)="onAutofill($event)"
                  />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="email">Work email</label>
            <p style="font-size: 14px">
              Use your work email, so that you don't miss key client or team
              notifications
            </p>
            <input
              required
              [(ngModel)]="ownerEmail"
              type="email"
              id="email"
              name="email"
              autocomplete="email"
              class="form-control"
              placeholder="Your work email address"
              cdkAutofill
              (cdkAutofill)="onAutofill($event)"
              />
            @if (lastValidatedEmail == ownerEmail && !validEmail) {
              <p
                style="font-size: 1rem; color: red"
                >
                {{ emailErrorMessage }}
              </p>
            }
          </div>
          <div class="form-group">
            <label for="phone">Phone</label>
            <input
              [(ngModel)]="ownerPhone"
              type="tel"
              id="phone"
              name="phone"
              autocomplete="tel"
              class="form-control"
              placeholder="Phone number"
              cdkAutofill
              (cdkAutofill)="onAutofill($event)"
              />
          </div>
          <!-- Password -->
          <div class="password-fields">
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label for="password">Your Account Password</label>
                  <input
                    [(ngModel)]="password"
                    type="password"
                    id="password"
                    name="password"
                    autocomplete="new-password"
                    class="form-control"
                    placeholder="Your password"
                    cdkAutofill
                    (cdkAutofill)="onAutofill($event)"
                    />
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="confirmpassword">Confirm Password</label>
                  <input
                    [(ngModel)]="confirmpassword"
                    type="password"
                    id="confirmpassword"
                    name="confirmpassword"
                    autocomplete="new-password"
                    class="form-control"
                    placeholder="Confirm your password"
                    (keyup.enter)="moveToStep2()"
                    cdkAutofill
                    (cdkAutofill)="onAutofill($event)"
                    />
                </div>
              </div>
            </div>
            <!-- Pass requirements -->
            <div class="password-requirements mb-5">
              <strong>Password requirements</strong>
              <div class="row">
                <div class="col-6">
                  <div
                    class="requirement"
                    [ngClass]="{ 'green-text': hasCapitalLetter() }"
                    >
                    <i
                      class="feather"
                    [ngClass]="{
                      circle: !hasCapitalLetter(),
                      'check-circle': hasCapitalLetter(),
                    }"
                    ></i>
                    Capital letters
                  </div>
                  <div
                    class="requirement"
                    [ngClass]="{ 'green-text': hasLowerCaseLetter() }"
                    >
                    <i
                      class="feather"
                    [ngClass]="{
                      circle: !hasLowerCaseLetter(),
                      'check-circle': hasLowerCaseLetter(),
                    }"
                    ></i>
                    Lower-case letters
                  </div>
                  <div
                    class="requirement"
                    [ngClass]="{ 'green-text': hasSymbols() }"
                    >
                    <i
                      class="feather"
                    [ngClass]="{
                      circle: !hasSymbols(),
                      'check-circle': hasSymbols(),
                    }"
                    ></i>
                    Symbols
                  </div>
                </div>
                <div class="col-6">
                  <div
                    class="requirement"
                    [ngClass]="{ 'green-text': hasNumbers() }"
                    >
                    <i
                      class="feather"
                    [ngClass]="{
                      circle: !hasNumbers(),
                      'check-circle': hasNumbers(),
                    }"
                    ></i>
                    Numbers
                  </div>
                  <div
                    class="requirement"
                    [ngClass]="{ 'green-text': hasEightChars() }"
                    >
                    <i
                      class="feather"
                    [ngClass]="{
                      circle: !hasEightChars(),
                      'check-circle': hasEightChars(),
                    }"
                    ></i>
                    At least 8 characters
                  </div>
                  <div
                    class="requirement"
                    [ngClass]="{ 'green-text': isConfirmPasswordSame() }"
                    >
                    <i
                      class="feather"
                    [ngClass]="{
                      circle: !isConfirmPasswordSame(),
                      'check-circle': isConfirmPasswordSame(),
                    }"
                    ></i>
                    Confirm password
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- UTM / campaign hidden fields (Contact Property + Hidden Field for HubSpot/GTM) -->
          <input type="hidden" name="utm_source" [value]="utmSource" />
          <input type="hidden" name="utm_medium" [value]="utmMedium" />
          <input type="hidden" name="utm_campaign" [value]="utmCampaign" />
          <input type="hidden" name="utm_term" [value]="utmTerm" />
          <input type="hidden" name="utm_content" [value]="utmContent" />

          <div class="form-group">
            <label for="referral-code">Referral Code (optional)</label>
            <input
              [(ngModel)]="referralCode"
              type="text"
              id="referral"
              name="referral"
              autocomplete="off"
              class="form-control"
              placeholder="Referral code"
              cdkAutofill
              (cdkAutofill)="onAutofill($event)"
              />
          </div>
          <div>
            <p style="font-size: 13px">
              By clicking to continue, you agree to our
              <a
                href="https://www.clienthub.app/terms-of-service"
                target="_blank"
                rel="noreferrer noopener"
                >Terms of Service</a
                >
                and
                <a
                  href="https://www.clienthub.app/privacy-policy"
                  target="_blank"
                  rel="noreferrer noopener"
                  >Privacy Policy</a
                  >.
                </p>
              </div>
              <div class="footer">
                @if (recaptchaV2Required) {
                  <div>
                    <!-- If a v2 challenge is required, display it -->
                    <re-captcha
                      class="mx-auto my-4 d-flex align-items-center justify-content-center"
                      (resolved)="onRecaptchaV2Resolved($event)"
                      (error)="onRecaptchaV2Error($event)"
                      (expired)="onRecaptchaV2Expired($event)"
                      siteKey="6LeK9BkrAAAAAKiPxsrK_v41C92nD5MGejo8aJSZ"
                      >
                    </re-captcha>
                  </div>
                }
                <button
                  class="btn btn-success btn-lg btn-block"
                  (click)="moveToStep2()"
                  [disabled]="validateForm() || validatePassword()"
                  >
                  Continue
                </button>
                <div style="height: 80px"></div>
              </div>
            </div>
          }

          <!-- Step 2: Payment -->
          @if (currStep === 2) {
            <div class="form">
              <div class="form-group">
                <label>Credit card</label>
                <div id="trial-card-element" class="form-control" style="padding-top: 8px;"></div>
                @if (cardError) {
                  <div class="text-danger mt-2">{{ cardError }}</div>
                }
                <div class="payment-info-card mt-2">
                  <div class="payment-info-icon">
                    <i class="tio-credit_card fs-3 color-blue"></i>
                  </div>
                  <p class="payment-info-text">
                    We ask for your payment details now to make continuing after your trial seamless.<br><strong>No charges during your trial</strong> — cancel anytime from Manage Practice page.
                  </p>
                </div>
              </div>
              <div class="footer">
                <button
                  class="btn btn-success btn-lg btn-block"
                  (click)="submitCardAndStartTrial()"
                  [disabled]="show_loading || isSubmittingTrial"
                  >
                  {{ show_loading ? "Starting trial…" : "Start trial" }}
                </button>
                <div style="height: 80px"></div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
